// Quantity buttons
document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-qty]');
  if (!t) return;
  const input = t.parentElement.querySelector('input[name="quantity"]');
  const v = parseInt(input.value || 1, 10);
  input.value = t.dataset.qty === 'inc' ? v + 1 : Math.max(1, v - 1);
});

// Thumb swap
document.querySelectorAll('.product-thumbs img').forEach((img) => {
  img.addEventListener('click', () => {
    const main = document.querySelector('[data-product-main-img]') || document.querySelector('.product-main-img');
    if (main) main.src = img.dataset.full || img.src;
    document.querySelectorAll('.product-thumbs img').forEach((i) => i.classList.remove('active'));
    img.classList.add('active');
  });
});

// Full description toggle
document.querySelectorAll('[data-longdesc-toggle]').forEach((btn) => {
  btn.addEventListener('click', () => {
    const wrap = btn.closest('.product-longdesc');
    const body = wrap && wrap.querySelector('.product-longdesc-body');
    if (!body) return;
    const open = body.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    const more = btn.querySelector('[data-more]');
    const less = btn.querySelector('[data-less]');
    if (more && less) {
      more.hidden = open;
      less.hidden = !open;
    }
  });
});

// Variant picker
(function () {
  const jsonEl = document.querySelector('[data-product-json]');
  const picker = document.querySelector('[data-variant-picker]');
  if (!jsonEl || !picker) return;

  let productData;
  try {
    productData = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }
  const variants = productData.variants || [];
  const moneyFmtEl = document.querySelector('[data-product-money-format]');
  let moneyFormat = '${{amount}}';
  try {
    moneyFormat = JSON.parse(moneyFmtEl.textContent) || moneyFormat;
  } catch (e) {}

  function formatMoney(cents) {
    if (cents == null) return '';
    const value = (cents / 100).toFixed(2);
    const parts = value.split('.');
    const withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const amount = withCommas + '.' + parts[1];
    const amountNoDec = withCommas;
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDec);
  }

  // Initialize selected from first available or first variant
  const initial = variants.find((v) => v.available) || variants[0];
  const selected = initial ? initial.options.slice() : [];

  function findVariant(opts) {
    return variants.find((v) => v.options.every((val, i) => val === opts[i]));
  }

  function updatePrice(variant) {
    const now = document.querySelector('[data-price-now]');
    const was = document.querySelector('[data-price-was]');
    const save = document.querySelector('[data-price-save]');
    if (!variant) return;
    if (now) now.textContent = formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (was) {
        was.textContent = formatMoney(variant.compare_at_price);
        was.hidden = false;
      }
      if (save) {
        const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        save.textContent = 'SAVE ' + pct + '%';
        save.hidden = false;
      }
    } else {
      if (was) { was.textContent = ''; was.hidden = true; }
      if (save) { save.textContent = ''; save.hidden = true; }
    }
  }

  function updateImage(variant) {
    if (!variant || !variant.featured_image) return;
    const main = document.querySelector('[data-product-main-img]');
    if (!main) return;
    const src = variant.featured_image.src || variant.featured_image;
    // Rewrite to width 900 if it's a Shopify CDN URL
    let url = typeof src === 'string' ? src : '';
    if (url && /cdn\.shopify\.com/.test(url)) {
      url = url.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, function (_m, ext, _e, q) {
        return ext + (q || '');
      });
      // add width query
      url = url.includes('?') ? url + '&width=900' : url + '?width=900';
    }
    main.src = url || main.src;

    // Sync thumbs
    const imgId = variant.featured_image.id;
    document.querySelectorAll('.product-thumbs img').forEach((t) => {
      const match = String(t.dataset.imageId) === String(imgId);
      t.classList.toggle('active', match);
    });
  }

  function updateAvailability(variant) {
    const btn = document.querySelector('[data-add-to-cart]');
    const dot = document.querySelector('[data-stock-dot]');
    const note = document.querySelector('[data-stock-note]');
    const idInput = document.querySelector('[data-variant-id]');
    if (!variant) {
      if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
      if (dot) dot.classList.add('is-out');
      if (note) note.textContent = 'This combination is not available';
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (btn) {
      btn.disabled = !variant.available;
      if (!variant.available) btn.textContent = 'Sold out';
    }
    if (dot) dot.classList.toggle('is-out', !variant.available);
  }

  function refresh() {
    const variant = findVariant(selected);
    updatePrice(variant);
    updateImage(variant);
    updateAvailability(variant);
    // Update selected value labels
    picker.querySelectorAll('.variant-option').forEach((optEl) => {
      const idx = parseInt(optEl.dataset.optionIndex, 10);
      const label = optEl.querySelector('[data-selected-value]');
      if (label) label.textContent = selected[idx] || '';
    });
  }

  picker.querySelectorAll('[data-option-value]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const idx = parseInt(btn.dataset.optionIndex, 10);
      const val = btn.dataset.value;
      selected[idx] = val;
      // Toggle selected state within this option group
      const group = btn.parentElement;
      group.querySelectorAll('[data-option-value]').forEach((b) => {
        const on = b === btn;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      refresh();
    });
  });

  refresh();
})();
